import { render, staticRenderFns } from "./tableDetailModal.vue?vue&type=template&id=2d93c268&scoped=true"
import script from "./tableDetailModal.vue?vue&type=script&lang=js"
export * from "./tableDetailModal.vue?vue&type=script&lang=js"
import style0 from "./tableDetailModal.vue?vue&type=style&index=0&id=2d93c268&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d93c268",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d93c268')) {
      api.createRecord('2d93c268', component.options)
    } else {
      api.reload('2d93c268', component.options)
    }
    module.hot.accept("./tableDetailModal.vue?vue&type=template&id=2d93c268&scoped=true", function () {
      api.rerender('2d93c268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insure/components/tableDetailModal.vue"
export default component.exports